
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33 0H15C6.717 0 0 6.717 0 15v18c0 8.283 6.717 15 15 15h18c8.283 0 15-6.717 15-15V15c0-8.283-6.717-15-15-15zm10.5 33c0 5.79-4.71 10.5-10.5 10.5H15C9.21 43.5 4.5 38.79 4.5 33V15C4.5 9.21 9.21 4.5 15 4.5h18c5.79 0 10.5 4.71 10.5 10.5v18z","fill":"#FF671B"}}),_c('path',{attrs:{"d":"M24 12c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 19.5c-4.134 0-7.5-3.366-7.5-7.5 0-4.137 3.366-7.5 7.5-7.5s7.5 3.363 7.5 7.5c0 4.134-3.366 7.5-7.5 7.5zM36.9 12.699a1.599 1.599 0 100-3.198 1.599 1.599 0 000 3.198z","fill":"#FF671B"}})])
          )
        }
      }
    